module.exports = __webpack_public_path__ + "img/u241.f556e776.png";